import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Udhyamservice() {
  

  return (
    <>
      <Header/>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="text-white">Udhyam</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Udyam</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <section id="about" className="about section light-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets\images\svg\udyam-1.png" alt className="h-100 w-100 p-2 img-fluid" />
            </div>
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  <b>Sai Financial Service</b> Provider offers professional assistance for Udyam registration, making the process simple and hassle-free for businesses. Below are the details of the content, terms, and conditions for our Udyam services:</p>
                <h3>Services terms&conditions:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b> New Udyam Registration:</b> Assistance in registering Micro, Small, and Medium Enterprises (MSMEs) under the Udyam Registration framework.</p></li>
                  <li><p className="fst-italic"><b>Updates and Corrections:</b> Support in updating or correcting details in an existing Udyam registration, including business name, address, or other key information</p></li>
                  <li><p className="fst-italic"><b>Service Fee Policy:</b> The ₹1,000 service fee is non-refundable, even in cases where the application is rejected due to errors in the provided information.</p></li>
                  <li><p className="fst-italic"><b>Government Fees:</b>Any applicable government fees for Udyam registration must be paid by the applicant directly.</p></li>
                  <li><p className="fst-italic"><b>Accuracy of Information:</b> Applicants are responsible for providing accurate and complete details. Sai Financial Service Provider is not liable for delays or rejections caused by incorrect or incomplete information.</p></li>
                  <li><p className="fst-italic"><b>Documentation Responsibility:</b> It is the applicant’s responsibility to submit all required documents as per government guidelines.</p></li>
                  {/* <li><p className="fst-italic"><b>Vehicle Loans:</b>This service is available for all major credit card networks, including Visa, MasterCard, and RuPay.</p></li>
                                    <li><p className="fst-italic"><b>Loan Against Property:</b>  Unlock the potential of your property to get funds for your business or personal needs.</p></li>
                                    <li><p className="fst-italic"><b>Others Loan:</b> We also provide other loan services like education loans, gold loans, agricultural loans and other loans designed to meet specific financial requirements.</p></li> */}
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                  <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                  <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                </ol>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">

            <h1 style={{ textAlign: 'center' }}>
              <span>Udyam</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default Udhyamservice
